import React from 'react';
import moment from 'moment';
import { useShowContext } from 'framework/show';
import { DATE_FORMAT } from 'framework/utils';
import { Box } from '@mui/material';
import { MappedLeaveItem } from '../../shared/types';

const LeavePeriodField = () => {
  const { data } = useShowContext<MappedLeaveItem>();
  const period = data?.getData();
  const startDate = period?.startDate || period?.period?.startDate;
  const endDate = period?.endDate || period?.period?.plannedEndDate;

  if (!startDate || !endDate) return null;

  const formatDate = (dateString: string) => moment(dateString).format(DATE_FORMAT.SIMPLE);

  return (
    <Box>
      {formatDate(startDate)} - {formatDate(endDate)}
    </Box>
  );
};

export default LeavePeriodField;
